import React from "react";
import { Row, Col, Container } from "reactstrap";
import "./Overview.css";

function Overview() {
  return (
    <Container fluid={true} className="Overview">
      <Container fluid={true} className="Overview-cover">
        <Row className="Overview-row">
          <Col sm="3" />
          <Col sm="6">
            <div className="Overview-info-block">
              <p>
                Plug-and-play particles into existing React projects using the
                same downloadable JSON configuration as the original{" "}
                <a href="http://vincentgarreau.com/particles.js/">
                  particles.js
                </a>
                . Configure multiple components independently using seperate
                JSON files.
              </p>
            </div>
          </Col>
          <Col sm="3" />
        </Row>
      </Container>
    </Container>
  );
}

export default Overview;
